import { render, staticRenderFns } from "./StudioTabs.vue?vue&type=template&id=7f428333&scoped=true"
import script from "./StudioTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioTabs.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioTabs.vue?vue&type=style&index=0&id=7f428333&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f428333",
  null
  
)

export default component.exports